import React, { useEffect, useState, useCallback } from 'react'
import { connect } from 'react-redux'
import { makeStyles, Drawer } from '@material-ui/core'

import StudentTopBar from './Components/StudentTopBar'
import StudentSidebar from './Components/StudentSidebar'
import MainMenu from '../../Components/NodeCapeeshPlayer/MainMenu/MainMenu'
import { studentActions } from '../../_state/actions'
import { CapeeshColors } from '../../assets/ColorPalette'
import { history } from '../../_state/helpers'

const MOBILE_BREAKPOINT = 600

const useStyles = makeStyles((theme) => ({
    page: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 60px)',
    },
    body: {
        display: 'flex',
        flex: 1,
    },
    content: {
        flex: 1,
        backgroundColor: CapeeshColors.EggShell2,
        backgroundImage: 'radial-gradient(circle at 1px 1px, rgb(225, 225, 221) 1px, transparent 0)',
        backgroundSize: '12px 12px',
        minHeight: 'calc(100vh - 60px)',
    },
    drawerPaper: {
        width: 220,
        top: 60,
    },
}))

const StudentMainMenu = (props) => {
    const { dispatch, student } = props
    const classes = useStyles()

    const [isMobile, setIsMobile] = useState(() => window.innerWidth < MOBILE_BREAKPOINT)
    const [drawerOpen, setDrawerOpen] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < MOBILE_BREAKPOINT
            setIsMobile(mobile)
            if (!mobile) setDrawerOpen(false)
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        dispatch(studentActions.getStudentInfo('web'))
        dispatch(studentActions.getStudentLanguageMetadata())
    }, [])

    const handleGoToRoot = () => {
        history.push('/student')
    }

    const handleDrawerToggle = useCallback(() => {
        setDrawerOpen((prev) => !prev)
    }, [])

    return (
        <React.Fragment>
            <div className={classes.page}>
                <StudentTopBar
                    dispatch={dispatch}
                    onGoToRoot={handleGoToRoot}
                    isInMobileView={isMobile}
                    onDrawerToggle={isMobile ? handleDrawerToggle : undefined}
                />
                <div className={classes.body}>
                    {!isMobile && <StudentSidebar />}
                    <div className={classes.content}>
                        <MainMenu />
                    </div>
                </div>
            </div>

            {isMobile && (
                <Drawer
                    anchor="left"
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                    classes={{ paper: classes.drawerPaper }}
                    ModalProps={{ keepMounted: true }}
                >
                    <StudentSidebar inDrawer />
                </Drawer>
            )}
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    const { student, studentAuth } = state
    return {
        student,
        studentAuth,
    }
}

export default connect(mapStateToProps)(StudentMainMenu)
